/*
 * Early Access popup modal trigger - manual only.
 *
 * Open/close, ESC, overlay-click-to-close, focus trap and body scroll lock
 * are all handled by Dawn's own <modal-dialog> custom element (see
 * assets/global.js: ModalDialog.show()/hide(), trapFocus/removeTrapFocus).
 * This file only opens the modal when the announcement bar is clicked - it
 * never auto-opens, never queries or modifies Shopify Forms' own rendered
 * markup, and never touches the native Shopify Forms Popup form (a
 * separate, independent system responsible for its own automatic 8-second
 * display and suppression via its own Display Rules).
 *
 * Re-runs on shopify:section:load so editing this section or the
 * announcement bar section in the Theme Editor doesn't leave the trigger
 * unbound. Guarded with dataset flags against duplicate listener binding
 * since the enclosing <script src> re-executes on every such reload.
 */
(function () {
  var MODAL_ID = 'soluscent-early-access-modal';

  function init() {
    var modal = document.getElementById(MODAL_ID);
    var trigger = document.querySelector('[data-soluscent-early-access-trigger]');

    if (!modal || !trigger) return;

    // Guard: only intercept the announcement bar link if the modal exists,
    // Dawn's modal-dialog custom element has upgraded (.show is a function),
    // and the Forms app block actually rendered something into it. Otherwise
    // leave the link alone so it falls back to a normal navigation to
    // /pages/early-access.
    var canOpen = typeof modal.show === 'function' && modal.dataset.hasForm === 'true';
    if (!canOpen) return;

    if (!trigger.dataset.earlyAccessBound) {
      trigger.dataset.earlyAccessBound = 'true';

      trigger.addEventListener('click', function (event) {
        event.preventDefault();

        // Idempotent: showing an already-open modal-dialog just re-focuses
        // it, so a rapid double-click can't stack a duplicate overlay.
        modal.setAttribute('aria-hidden', 'false');
        modal.show(trigger);
      });
    }

    // Dawn's modal-dialog dispatches 'modalClosed' on document.body whenever
    // ANY modal-dialog on the page hides (ESC, overlay click, close button).
    // Bound once on body (survives section reloads), so re-derive this
    // modal's own aria-hidden by id rather than capturing a stale reference.
    if (!document.body.dataset.earlyAccessModalClosedBound) {
      document.body.dataset.earlyAccessModalClosedBound = 'true';

      document.body.addEventListener('modalClosed', function () {
        var current = document.getElementById(MODAL_ID);
        if (current) {
          current.setAttribute('aria-hidden', current.hasAttribute('open') ? 'false' : 'true');
        }
      });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (event) {
    if (
      event.target.querySelector('#' + MODAL_ID) ||
      event.target.querySelector('[data-soluscent-early-access-trigger]')
    ) {
      init();
    }
  });
})();
